var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-icon',{attrs:{"icon":_vm.icon,"font-scale":"1","variant":_vm.variant}})
}
var staticRenderFns = []

export { render, staticRenderFns }